<template>
  <Container type="card-full">
    <div slot="header" v-if="type === 1 || type === 2">
      <el-button @click="addOrEdit" :loading="btnLoading" v-if="showButton == 0">保存</el-button>
    </div>
    <div class="main">
      <el-form :model="prs" ref="ruleForm" label-position="right" class="mainfrom from_input">
        <el-form-item label="项目名称" class="from-value">
          {{project.projectname}}
        </el-form-item>
        <div class="row">
          <el-form-item label="报名开始时间" prop="prsbmbegtime" verify>
            <el-date-picker v-model="prs.prsbmbegtime" type="datetime" :disabled="disable"
                            placeholder="选择日期时间" :picker-options="pickerOptions"></el-date-picker>
          </el-form-item>
          <el-form-item label="报名截止时间" prop="prsbmendtime" :verify="validatebmend">
            <el-date-picker v-model="prs.prsbmendtime" type="datetime" :disabled="disable"
                            placeholder="选择日期时间" :picker-options="pickerOptions"></el-date-picker>
<!--            <el-checkbox v-model="prs.prsbmneedconfirm">报名需要确认</el-checkbox>-->
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item label="报价开始时间" prop="prsbjbegtime" :verify="validatebjbegin">
            <el-date-picker v-model="prs.prsbjbegtime" type="datetime" :disabled="disable"
                            placeholder="选择日期时间"  :picker-options="pickerOptions"></el-date-picker>
          </el-form-item>

          <el-form-item label="报价截止时间" prop="prsbjendtime" :verify="validatebjend">
            <el-date-picker v-model="prs.prsbjendtime" type="datetime" :disabled="disable"
                            placeholder="选择日期时间"  :picker-options="pickerOptions"></el-date-picker>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item label="报价公开" prop="prsisopen" verify>
            <el-select v-model="prs.prsisopen" :clearable="true" :disabled="disable">
              <el-option v-for="(item, index) in prsisopenList" :label="item.label" :value="item.value"
                         :key="index"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="报价次数" prop="prsbjtimes" verify :gt="0">
            <el-input v-model="prs.prsbjtimes" :maxlength="2" :disabled="disable"></el-input>
          </el-form-item>
        </div>
        <div class="row">

          <el-form-item label="出价方式" prop="prsflg" verify>
            <el-select v-model="prs.prsflg" :clearable="true" :disabled="disable">
              <el-option v-for="(item, index) in prsflgList" :label="item.label" :value="item.value"
                         :key="index"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="有效报名家数" prop="prssupplynums" verify :gte="0">
            <el-input v-model="prs.prssupplynums" :maxlength="12" :disabled="disable"></el-input><span style="color:red;">0表示不受限</span>
          </el-form-item>
          <!-- <el-form-item label="最后报价">
            <el-input v-model.number="prs.prsnmin" :maxlength="4"  :disabled="disable">
              <template slot="append">分钟后无报价，自动结束</template>
            </el-input>
          </el-form-item> -->
        </div>
        <div class="row" v-if="project.projecttype == 1">
          <el-form-item label="报名审核" prop="prsbmneedconfirm" verify>
            <el-select v-model="prs.prsbmneedconfirm" :clearable="true" :disabled="disable">
              <el-option v-for="(item, index) in prsbmneedconfirmList" :label="item.label" :value="item.value"
                         :key="index"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="row" v-if="project.projecttype == 1">
          <el-form-item label="收费标准" prop="prschangeflg" verify>
            <el-select v-model="prs.prschangeflg" :clearable="true" :disabled="disable">
              <el-option v-for="(item, index) in prschangeflgList" :label="item.label" :value="item.value"
                         :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="服务费" prop="prschangefee" verify :gte="0" v-if="prs.prschangeflg == 2">
            <el-input v-model="prs.prschangefee" :maxlength="12" :disabled="disable"></el-input>
          </el-form-item>
        </div>
        <!-- <div class="row" v-if="project.projectdoneflg !== '1'">

          <el-form-item label="外部评审人人数" prop="prswexperts" verify :gte="0">
            <el-input v-model="prs.prswexperts" :maxlength="4" :disabled="disable"></el-input>
          </el-form-item>

          <el-form-item label="内部评审人人数" prop="prsnexperts" verify :gte="0">
            <el-input v-model="prs.prsnexperts" :maxlength="4" :disabled="disable"></el-input>
          </el-form-item>
        </div> -->
        <div class="content">
          <el-form-item label="项目需求" :required="true">
            <div v-if="disable == true" >
              <div v-html="prs.prscontents" style="margin-top:-12px"></div>
            </div>
            <div v-show = "disable == false">
              <div ref="editor" style="text-align:left"></div>
            </div>
          </el-form-item>
          <div class="error">{{errorMsg}}</div>
        </div>
        <el-form-item label="备注">
          <div v-if="disable == true">
            <div>{{prs.prsremark}}</div>
          </div>
          <div v-else>
            <el-input v-model="prs.prsremark" :maxlength="255" show-word-limit type="textarea"></el-input>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </Container>
</template>

<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  import config from '../../assets/config'
  import common from '@/mixin/common'
  import E from 'wangeditor'
  import dayjs from 'dayjs'
  export default {
    name: "prsForm",
    mixins: [common],
    props: {
      cproject: Object,
      ctype: Number
    },
    data () {
      return {
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() <= Date.now()- 86400000;
          }
        },
        project: this.cproject || this.$route.params.form,
        type: this.ctype || Number(this.$route.params.type),
        disable: this.type === 3 ? true : false,
        btnLoading: false,
        prs: {},
        prsisopenList: [],
        prsflgList: [],
        prschangeflgList:[],
        prsbmneedconfirmList:[],
        editorContent: '',
        editor: '',
        errorMsg: '',
        Nonproject:true,
        showButton:Number(this.$route.params.form.projectstatus) === 10 ? 0 : 1
      }
    },
    created () {
    },
    async activated () {
      this.init()
      this.getPrsisopenList()
      this.getPrsflgList()
      this.getprschangeflgList()
      this.getprsbmneedconfirm()
      await this.getPageList()
      await this.initEditor()
    },
    async mounted () {
      // this.init()
      // this.getPrsisopenList()
      // this.getprschangeflgList()
      // this.getprsbmneedconfirm()
      // this.getPrsflgList()
      // this.getPageList()
    },
    watch: {
      $route (to, from) {
        to.name === 'prsForm'
      }
    },
    filters: {},
    components: {},
    computed: {},
    deactivated () {
      this.$destroy()
    },
    methods: {
      validatebmend(rule, val, callback) {
        if (dayjs(val).valueOf() <= dayjs(this.prs.prsbmbegtime).valueOf()) {
          callback(Error('报名结束时间不能小于等于报名开始时间'))
        } else {
          callback()
        }
      },
      validatebjbegin(rule, val, callback) {
        if (dayjs(val).valueOf() <= dayjs(this.prs.prsbmendtime).valueOf()) {
          callback(Error('报价开始时间不能小于等于报名结束时间'))
        } else {
          callback()
        }
      },
      validatebjend(rule, val, callback) {
        if (dayjs(val).valueOf() <= dayjs(this.prs.prsbjbegtime).valueOf()) {
          callback(Error('报价结束时间不能小于等于报价开始时间'))
        } else {
          callback()
        }
      },
      async init () {
        this.project = this.cproject || this.$route.params.form
        this.type = this.ctype || Number(this.$route.params.type)
        this.disable = this.type === 3 ? true : false
        this.btnLoading = false
        this.prs = {}
        this.prsisopenList = []
        this.prs.prschangeflg = ""
        this.prschangeflgList = []
        this.prsbmneedconfirmList = []
        this.prsflgList = []
        this.editorContent = ''
        this.editor = ''
        if(this.$route.params.form.projectstatus > 10){
          this.showButton = 1
          this.disable = true
        }
        if(Number(this.ctype) === 3){
          this.showButton = 1
          this.disable = true
        }
      },
      async initEditor () {
        if (this.editor) {
          this.editor.txt.html(this.prs.prscontents)
          return
        }
        this.editor = new E(this.$refs.editor)
        this.editor.config.onchange = (html) => {
          this.editorContent = html
        }
        this.editor.config.uploadFileName = 'file'
        this.editor.config.uploadImgServer = `${config.baseUrl}upload/upload`
        this.editor.config.zIndex = 1
        this.editor.create()
        this.editor.txt.html(this.prs.prscontents)
      },
      async getPageList () {
        let res = await request({
          method: 'get',
          url: '/xmgl/project/getPrsList',
          params: {projectid: this.project.projectid}
        })
        if (res.length > 0) {
          this.prs = res[0]
          this.editorContent = this.prs.prscontents
          if(this.prs.prsbmneedconfirm){
            this.prs.prsbmneedconfirm = this.prs.prsbmneedconfirm.toString()
          }
          // this.prs.prsbmneedconfirm = this.prs.prsbmneedconfirm === 1 ? true : false
        } else {
          this.prs = {
            prsid: 0,
            prsprojectid: this.project.projectid,
            prssupplynums: 0
          }
        }
      },
      async getPrsisopenList () {
        this.prsisopenList = await request({
          url: '/kfgl/syscode/getSysCodeList',
          method: "get",
          params: {syscode: 'prsisopen'}
        })
      },
      async getPrsflgList () {
        this.prsflgList = await request({
          url: '/kfgl/syscode/getSysCodeList',
          method: "get",
          params: {syscode: 'prsflg'}
        })
      },
      async getprschangeflgList () {
        this.prschangeflgList = await request({
          url: '/kfgl/syscode/getSysCodeList',
          method: "get",
          params: {syscode: 'prschangeflg'}
        })
      },
      async getprsbmneedconfirm () {
        this.prsbmneedconfirmList = await request({
          url: '/kfgl/syscode/getSysCodeList',
          method: "get",
          params: {syscode: 'prsbmneedconfirm'}
        })
        console.log('====prsbmneedconfirmList=====',this.prsbmneedconfirmList);
        
      },
      async addOrEdit () {
        this.btnLoading = true
        console.log(this.editorContent, 999999999)
        if (!this.editorContent) {
          this.errorMsg = '请输入内容'
          this.btnLoading = false
          return
        } else {
          this.errorMsg = ""
        }
        this.submitForm('ruleForm').then(async() => {
          if (this.project.projectstatus !== '10') {
            this.$message.error('项目公告已发布，不能修改竞价规则！')
            return
          }
          if (!this.editorContent) {
            this.errorMsg = '请输入内容'
            this.btnLoading = false
            return
          } else {
            this.errorMsg = ""
          }
          this.prs.prscontents = this.editorContent
          this.prs.prsbmbegtime = utils.formatterDate(this.prs.prsbmbegtime, 'yyyy-MM-dd HH:mm:ss')
          this.prs.prsbmendtime = utils.formatterDate(this.prs.prsbmendtime, 'yyyy-MM-dd HH:mm:ss')
          this.prs.prsbjbegtime = utils.formatterDate(this.prs.prsbjbegtime, 'yyyy-MM-dd HH:mm:ss')
          this.prs.prsbjendtime = utils.formatterDate(this.prs.prsbjendtime, 'yyyy-MM-dd HH:mm:ss')
          this.prs.prsbmneedconfirm = Number(this.prs.prsbmneedconfirm)
          // this.prs.prsbmneedconfirm = this.prs.prsbmneedconfirm === true ? 1 : 0
          // this.prs.prsbmneedconfirm = 1
          let data = await request({
            url: '/xmgl/project/addOrEdit',
            method: "post",
            data: this.prs
          })
          if (data.issuccess === 1) {
            this.close()
            this.$message.success('保存成功')
          } else {
            this.$message.error('保存失败')
          }
        }).catch(() => {
        })
        this.btnLoading = false
      },
      close () {
        let returnForm = 'projectIndex'
        if (this.project.projecttype === '2') {
          returnForm = 'projectZjIndex'
        }
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: returnForm})
      }
    }
  }
</script>

<style lang="scss" scoped>
  .main {
    .from_input .el-input, .el-input .el-input__inner, .el-select {
      width: 225px;
    }
    .content .el-textarea__inner, .el-textarea {
      width: 690px;
    }
    .el-input-group__append, .el-input-group__prepend {
      padding: 0px 5px;
    }
  }
</style>

